import BScroll from "better-scroll";
import dataConfig from "../../baseConfig/dataConfig";
import httpConfig from "../../baseConfig/httpConfig";
import tools from "../../utils/fun";

var gamePopTools = {};

/**
 * 获取不同模式下的数组长度
 * @param {*} list 
 * @param {*} isDemo 
 */
gamePopTools.getListLen = function (list, isDemo) {
    let counter = 0;
    for (let i = 0; i < list.length; i++) {
        if (list[i].isDemo == isDemo) counter++;
    }
    return counter;
}

gamePopTools.initScroll = function (self) {
    if (self._scroll) {
        self._scroll.refresh();
    } else {
        let params = {
            startX: 0,
            scrollX: true,
            scrollY: false,
            probeType: 1,
            //1 滚动的时候会派发scroll事件，会截流。2滚动的时候实时派发scroll事件，不会截流。 3除了实时派发scroll事件，在swipe的情况下仍然能实时派发scroll事件
            click: true,
            momentum: true, //当快速滑动时是否开启滑动惯性
            bounce: true, //是否启用回弹动画效果
        };
        self._scroll = new BScroll(self.$refs.popWrapper, params);
    }
}

gamePopTools.resetScroll = function (self, len) {
    let width = 2.8 * len + 0.5;
    if (self.$refs.popWrapperContainer) {
        self.$refs.popWrapperContainer.style.width = width + "rem";
        if (self._scroll) {
            self._scroll.refresh();
        }
    }
}

gamePopTools.resetWinings = function (self, list, index) {
    let num = index == 0 ? 2 : 6;
    for (let i = 0; i < list.length; i++) {
        if (!list[i].isDemo) {
            let val = list[i].pointNumber * num * 0.9;
            list[i].join = self.$t("components.home.win") + tools.formateNumber(val, true);
        }
    }
}

gamePopTools.getConfig = function (self, key) {
    let keysArr = key.split("_");
    let config = dataConfig.rummyConfig[keysArr[0]];
    if (keysArr.length > 1) config = config[keysArr[1]];

    let rlt = {
        popType: config.popType,
        gameId: config.localGameId,
        demoId: config.demoGameId,
        list: []
    }
    let cn = self.$store.getters["common/getChannel"];

    let repStr1 = "rules";

    let repStr2 = "rules";
    if (dataConfig.fullGameChannels.indexOf(cn) != -1)
        repStr2 = "rules2";
    if (config.popType == 1) {
        for (let i = 0; i < config.rules.length; i++) {
            let img = tools.changeTowebp(config.rules[i].img.replace(repStr1, repStr2));
            let join = config.rules[i].join;
            join && (join = tools.formateNumber(join, true));
            !join && (join = self.$t("components.home.free"));
            rlt.list.push({
                img: img,
                points: (self.$t("components.home.point") + config.rules[i].points),
                join: (self.$t("components.home.join") + join),
                id: config.rules[i].key,
                pointNumber: config.rules[i].points,
                isDemo: (config.rules[i].join > 0 ? false : true)
            });
        }
    } else if (config.popType == 2) {
        for (let i = 0; i < config.rules.length; i++) {
            let img = tools.changeTowebp(config.rules[i].img.replace(repStr1, repStr2));
            let fee = tools.formateNumber(config.rules[i].fee, true);
            let win = config.rules[i].win;
            win && (win = tools.formateNumber(config.rules[i].fee * 2 * 0.9, true));
            !win && (fee = self.$t("components.home.free"), win = " -");
            rlt.list.push({
                img: img,
                points: (self.$t("components.home.fee") + fee),
                join: (self.$t("components.home.win") + win),
                id: 0,
                pointNumber: config.rules[i].fee,
                isDemo: (config.rules[i].win > 0 ? false : true)
            });
        }
        rlt.pools = tools.deepClone(config.pools);
        rlt.players = tools.deepClone(config.players);
        rlt.keys = tools.deepClone(config.keys);
    }
    return rlt;
}

export default gamePopTools;


// WEBPACK FOOTER //
// ./src/components/home/game_pop_tools.js